import { Observable } from 'rxjs/Observable';
import { observeCta } from "../eventDataSourceUpgrades/observeCta";
import { EventSource } from './eventSource';

import 'rxjs/add/observable/interval'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/switchMap'

export class EventRSVP {
    private ds: any;
    constructor(eventSource: EventSource) {
      this.ds = eventSource.getDatasource();
    }

    // todo change return type
    public observeCta(): Observable<any> {
      return new Observable(observer => {

        const listener = {
          onValue: val => observer.next(val),
          onError: err => (err.code !== "PERMISSION_DENIED") ? observer.error(err) : null
        };

        let l = observeCta(this.ds, listener);
        observer.add(() => {
          this.ds._observers.splice(this.ds._observers.indexOf(observer), 1);
        })
      }).publishReplay().refCount()
    }
}
